import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import BuscadorEmpresas from "./BuscadorEmpresas";
import EmpresaAltaModal from "./EmpresaAltaModal";
import { useEffect } from "react";
import EmpresaModal from "./EmpresaModal";
import { fetchSeccionales } from "../../actions/cbos/seccionales";
import { fetchLocalidades } from "../../actions/cbos/localidades";
import { fetchProvincias } from "../../actions/cbos/provincias";
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    colorSeleccionado: theme.palette.text.primary,
    colorDeseleccionado: theme.palette.text.secondary,
}));

export const EmpresasScreen = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const [abrirEmpresaModal, setAbrirEmpresaModal] = useState(false);

    const [checkingData, setCheckingData] = useState(true);
    const [altaModal, setAltaModal] = useState(false)

    const { empresaABM } = useSelector((state) => state.empresas);
    const { items: seccionales, cargada: listaSecCargada } = useSelector((state) => state.seccionales);
    const { items: localidades, cargada: listaLocCargada } = useSelector((state) => state.localidades);
    const { items: provincias, cargada: listaProvCargada } = useSelector((state) => state.provincias);
    
    useEffect(() => {
        if (!listaSecCargada) {
          dispatch(fetchSeccionales());
        }
        setCheckingData(false);
      }, [dispatch, seccionales, listaSecCargada]);

      useEffect(() => {
        if (!listaLocCargada) {
          dispatch(fetchLocalidades());
        }
        setCheckingData(false);
      }, [dispatch, localidades, listaLocCargada]);

      useEffect(() => {
        if (!listaProvCargada) {
          dispatch(fetchProvincias());
        }
        setCheckingData(false);
      }, [dispatch, provincias, listaProvCargada]);

    useEffect(() => {
        if (empresaABM && !altaModal) {
            setAbrirEmpresaModal(true)
        }
    }, [empresaABM, altaModal]);


    if (checkingData) {
        return <h1>Cargando....</h1>;
      }
      
    return (
        <div className={classes.root}>
            <Grid
                container
                spacing={1}
                direction="row"
                justify="center"
                alignItems="center"
            >
                <Grid item xs={12} styles={{ padding: 5 }}>
                    <Button style={{float:"right", marginTop:"1rem"}} color='primary' variant='contained' onClick={()=>setAltaModal(true)}>+ AGREGAR NUEVA EMPRESA</Button>
                </Grid>
                <Grid item xs={12} sm={4} md={6}><BuscadorEmpresas titulo={true} setAbrirEmpresaModal={setAbrirEmpresaModal} /></Grid>
                
                <EmpresaModal item={empresaABM} abrirModal={abrirEmpresaModal} setAbrirModal={setAbrirEmpresaModal} />
                <EmpresaAltaModal item={empresaABM} abrirModal={altaModal} setAbrirModal={setAltaModal} />
            </Grid>
        </div>
    );
};
